/**
 * Database type.
 */
export type DatabaseType =
    | "mysql"
    | "postgres"
    | "cockroachdb"
    | "sap"
    | "mariadb"
    | "sqlite"
    | "sqlite-pooled"
    | "cordova"
    | "react-native"
    | "nativescript"
    | "sqljs"
    | "oracle"
    | "mssql"
    | "mongodb"
    | "aurora-mysql"
    | "aurora-postgres"
    | "expo"
    | "better-sqlite3"
    | "capacitor"
    | "spanner"
    | "libsql"
